export enum Types {
	CONSULTAR_DIGITAIS_IIRGD_REQUEST = '@utils/CONSULTAR_DIGITAIS_IIRGD_REQUEST',
	CONSULTAR_DIGITAIS_IIRGD_SUCCESS = '@utils/CONSULTAR_DIGITAIS_IIRGD_SUCCESS',
	CONSULTAR_DIGITAIS_IIRGD_FAILURE = '@utils/CONSULTAR_DIGITAIS_IIRGD_FAILURE',
	CONSULTAR_DIGITAIS_IIRGD_CLEAR = '@utils/CONSULTAR_DIGITAIS_IIRGD_CLEAR',
}
export interface ConsultarDigitaisIIRGDRequest {
	evento: {
		id_atendimento: string;
		id_cidadao: string;
		cpf: string;
		identificacao: string;
		ip: string;
		canal: {
			id: number;
			desc: string;
			estacao?: {
				id?: number;
				desc?: string;
			};
			localidade: {
				id: number;
				desc: string;
			};
		};
	};
	idPessoa?: string;
	idAtendimento?: string;
	rgSp: string;
	cpf: string;
	finalidade: string;
	// finalidade: 'REUSO_IIRGD';
	dataNascimento: string;
	incluirPendentes: boolean;
	incluirAnomalias: boolean;
	reuso: boolean;
}
export interface ConsultarDigitaisIIRGDState {
	status: number;
	data: ConsultaDigitaisIIRGD | null;
	mensagens: string[] | null;
}

interface ConsultaDigitaisIIRGD {
	dadosBiometricos: DadosBiometricosIIRGD[];
	valida: boolean;
	origem: string;
	motivo: string;
}

export interface DadosBiometricosIIRGD {
	dedo: string | number;
}

export type ConsultarDigitaisUserErrorMessages = 'pessoa-desconhecida';

export type ConsultarDigitaisUserReasonMessages = 'fora-da-temporalidade';
